import { Button, Flex, Text } from '@chakra-ui/react';
import { useRouter } from 'next/navigation';
import React from 'react';
import { DialogBody, DialogContent, DialogRoot } from '~/components/ui/dialog';

import { useI18nLn } from '~/hooks/store';

type Props = {
  isOpen: boolean;
  onClose: () => void; // モーダルを閉じる
  title: string;
  return_url: object | string | null; // ログインorサインアップ後に遷移するページ
};

export const LoginAlertModal: React.FC<Props> = (props: Props) => {
  const router = useRouter();
  const { t } = useI18nLn();
  const onClose = () => {
    props.onClose();
  };

  const handleLogin = () => {
    router.push(`/login?return_url=${returnUrl()}`);
  };

  const handleSignup = () => {
    router.push(`/signup?return_url=${returnUrl()}`);
  };

  const returnUrl = () => {
    if (typeof props.return_url === 'object') {
      return JSON.stringify(props.return_url);
    }
    if (typeof props.return_url === 'string') {
      return props.return_url;
    }
    return null;
  };

  return (
    <DialogRoot open={props.isOpen} onInteractOutside={onClose} size="xs">
      <DialogContent mx={12}>
        <DialogBody px={0} display="flex" flexDir="column" mx={4} my={2}>
          <Flex
            flexDir="column"
            justifyContent="center"
            alignItems="center"
            my={4}
            fontWeight="semibold"
          >
            <Text textAlign="center" whiteSpace="pre-wrap">
              {t('guide.login_alert.title')}
            </Text>
            <Text textAlign="center" fontWeight="light" mt={2}>
              {t('guide.login_alert.description')}
            </Text>
          </Flex>
          <Button
            onClick={handleLogin}
            my={1}
            bgColor="primary"
            variant="solid"
            colorPalette="primary"
          >
            {t('guide.login_alert.login_button')}
          </Button>
          <Button onClick={handleSignup} my={1} variant="outline">
            {t('guide.login_alert.signup_button')}
          </Button>
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  );
};
